import { useQuery } from "@tanstack/react-query";
import { fetchOfficeInfo } from "../services/officeInfoService";

export const useFetchOfficeInfo = () => (
    useQuery({
        queryKey: ['officeInfo'],
        queryFn: fetchOfficeInfo
    })
)